"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.codeSplit = exports.CodeSplit = void 0;
/* eslint-disable max-classes-per-file */
var React = require("react");
var CodeSplit = /** @class */ (function (_super) {
    __extends(CodeSplit, _super);
    function CodeSplit(props) {
        return _super.call(this, props) || this;
    }
    CodeSplit.loadRoute = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error('loadRoute not implemented');
            });
        });
    };
    CodeSplit.componentLoaded = false;
    return CodeSplit;
}(React.Component));
exports.CodeSplit = CodeSplit;
/**
 * Gets the appropriate name of a code split component.
 *
 * @param WrappedComponent The internally loaded React component.
 */
var getDisplayName = function (WrappedComponent) { return WrappedComponent.displayName || WrappedComponent.name || 'Component'; };
/**
 * Produces a new React component class that asynchronously loads the internal component.
 *
 * For use with dynamic imports. See more:
 * - Mozilla: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import#Dynamic_Imports
 * - Webpack: https://github.com/webpack/webpack.js.org/blob/master/src/content/guides/code-splitting.md#dynamic-imports
 * --- or use commit hash b77b222c1c52873f7d8b2fb66573598ef4ad5232 instead of master
 *
 * @param {CodeSplitLoader} loaderFunction A function that returns a `Promise` containing an object with a default
 * export of a React component. Bernie is unable to know any specifics of the imported component, therefore it requires
 * a default export so it has something to run. It will throw an error if a default export is not found.
 */
var codeSplit = function (loaderFunction) {
    // tslint:disable-next-line:max-classes-per-file
    return (/** @class */ (function (_super) {
        __extends(WebpackRoute, _super);
        function WebpackRoute(props) {
            var _this = _super.call(this, props) || this;
            _this.logger = {};
            _this.state = { component: WebpackRoute.wrappedComponent };
            if (!_this.state.component) {
                _this.doLoadRoute(false);
            }
            return _this;
        }
        WebpackRoute.prototype.componentDidMount = function () {
            if (!this.state.component) {
                this.doLoadRoute();
            }
        };
        WebpackRoute.prototype.render = function () {
            var Component = this.state.component;
            var loadingComponent = this.props.loadingState || null;
            return Component ? React.createElement(Component, __assign({}, this.props)) : loadingComponent;
        };
        WebpackRoute.prototype.doLoadRoute = function (setState) {
            if (setState === void 0) { setState = true; }
            return __awaiter(this, void 0, void 0, function () {
                var component, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, WebpackRoute.loadRoute()];
                        case 1:
                            component = _a.sent();
                            if (setState) {
                                this.setState({ component: component });
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _a.sent();
                            if (this.logger && this.logger.error) {
                                this.logger.error(error_1);
                            }
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        WebpackRoute.loadRoute = function () {
            return __awaiter(this, void 0, void 0, function () {
                var component;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!WebpackRoute.componentLoaded) return [3 /*break*/, 2];
                            return [4 /*yield*/, loaderFunction()];
                        case 1:
                            component = _a.sent();
                            if (!component || !component.default) {
                                throw new Error('Code split components must have a default export');
                            }
                            WebpackRoute.wrappedComponent = component.default;
                            WebpackRoute.displayName = "WebpackRoute(".concat(getDisplayName(component.default), ")");
                            WebpackRoute.componentLoaded = true;
                            _a.label = 2;
                        case 2: return [2 /*return*/, WebpackRoute.wrappedComponent];
                    }
                });
            });
        };
        return WebpackRoute;
    }(CodeSplit)));
};
exports.codeSplit = codeSplit;
//# sourceMappingURL=code-split.js.map